// extracted by mini-css-extract-plugin
export default {"tooltip":"up-z","sharingV2":"vp-z","sharingIconsV2":"wp-z","links":"xp-z","link":"yp-z","facebookV2":"zp-z","twitterV2":"Ap-z","pinterestV2":"Bp-z"};